module.exports = __webpack_public_path__ + "img/reDone.88ca2ad1.png";